module.exports = __webpack_public_path__ + "static/media/Personalized_Patterns_Soundwave.aeef2d6b.png";